// extracted by mini-css-extract-plugin
export default {"dialog":"ReadonlySettingsDialog_dialog__BHPgh","layout":"ReadonlySettingsDialog_layout__ihpWQ","description":"ReadonlySettingsDialog_description__oe2+D"};